import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  aif_name: {
    name: 'Master AIF Name'
  },
  domicile: {
    name: 'Master AIF national identifier - Reporting Member State'
  },
  master_aif_national_code: {
    name: 'Master AIF national identifier - National code'
  }
};

export function MasterAIF({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.MASTER_AIF,
    onChangeFund,
    schema: schema.MASTER_AIF,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.MASTER_AIF?.field_names || [],
    tableName: 'MASTER_AIF',
    order: 42,
    columnLables,
    isMultiFunds,
    funds,
    onAddColumn,
    onDeleteColumn,
    hasTableOrderNumber: false
  });

  return (
    <Table
      id="reporttables-master-aif-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
      stickyTopRows={isMultiFunds ? 1 : null}
    />
  );
}
